import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
export function StackShell(props) {
    const { before = _jsx("div", {}), after = _jsx("div", {}), children = _jsx("div", {}), ...rest } = props;
    return (_jsxs(StackShellRoot, { ...rest, children: [before, children, after] }));
}
const StackShellRoot = styled.div `
    display: grid;
    grid-template-rows: auto 1fr auto;
    height: 100%;
    overflow: hidden;
`;
